import { useState } from 'react';

export default function AddMenuModal({ 
  show, 
  onClose, 
  title, 
  onSave, 
  isSubmenu,
  newMenuName,
  setNewMenuName,
  newMenuUrl,
  setNewMenuUrl,
  newMenuIcon,
  setNewMenuIcon,
  newMenuSequence, // New prop for sequence
  setNewMenuSequence // New prop for sequence setter
}) {
  if (!show) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-xl w-full max-w-md mx-auto max-h-[90vh] overflow-y-auto">
        <h3 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6 text-gray-900 border-b pb-2">
          {title}
        </h3>
        
        <div className="space-y-4 sm:space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Menu Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={newMenuName}
              onChange={(e) => setNewMenuName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="Enter menu name"
              autoFocus
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              URL
            </label>
            <input
              type="text"
              value={newMenuUrl}
              onChange={(e) => setNewMenuUrl(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="/"
            />
            <p className="mt-1 text-xs text-gray-500">
              Leave empty to use default "/"
            </p>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Icon
            </label>
            <input
              type="text"
              value={newMenuIcon}
              onChange={(e) => setNewMenuIcon(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder={isSubmenu ? "icon" : "MessageSquare"}
            />
            <p className="mt-1 text-xs text-gray-500">
              Icon name for the menu item
            </p>
          </div>

          {/* New Sequence Field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Sequence
            </label>
            <input
              type="number"
              value={newMenuSequence}
              onChange={(e) => setNewMenuSequence(e.target.value === '' ? '' : Number(e.target.value))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="Enter sequence number"
              min="0"
            />
            <p className="mt-1 text-xs text-gray-500">
              Order in which menu items will appear.
            </p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6 sm:mt-8 pt-4 border-t">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md text-sm font-medium disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
            disabled={!newMenuName.trim()}
          >
            {title.includes('Edit') ? 'Update' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}